"use client";

import React from "react";
import {Grid, Skeleton} from "@mui/material";

const style = {
  height: "25rem",
  width: "100%",
  display: "flex"
};

const CrowdRiffGallerySkeleton = () => (
  <Grid spacing={1} container width="100%">
    <Grid
      size={{
        xs: 6,
        sm: 4,
        md: 2
      }}
    >
      <Skeleton sx={style} variant="rectangular" />
    </Grid>
    <Grid
      size={{
        xs: 6,
        sm: 4,
        md: 3
      }}
    >
      <Skeleton sx={style} variant="rectangular" />
    </Grid>
    <Grid
      size={{
        xs: 12,
        sm: 4,
        md: 2
      }}
    >
      <Skeleton sx={style} variant="rectangular" />
    </Grid>
    <Grid
      size={{
        xs: 6,
        sm: 6,
        md: 3
      }}
    >
      <Skeleton sx={style} variant="rectangular" />
    </Grid>
    <Grid
      size={{
        xs: 6,
        sm: 6,
        md: 2
      }}
    >
      <Skeleton sx={style} variant="rectangular" />
    </Grid>
  </Grid>
  );

export default CrowdRiffGallerySkeleton;